import { __extends } from "tslib";
import { TaskBaseWebGL } from './webgl/TaskBaseWebgGL';
var BlurTask = /** @class */ (function (_super) {
    __extends(BlurTask, _super); /*Filter3DTaskBase*/
    /**
     * @param amount The maximum amount of blur to apply in pixels at the most out-of-focus areas
     * @param stepSize The distance between samples. Set to -1 to autodetect with acceptable quality.
     * @param horizonal Pass direction
     */
    function BlurTask(amount, stepSize, horizonal) {
        if (stepSize === void 0) { stepSize = -1; }
        if (horizonal === void 0) { horizonal = true; }
        var _this = _super.call(this) || this;
        _this.horizontalPass = true;
        _this._stepSize = 1;
        _this._amount = amount;
        _this._data = new Float32Array([0, 0, 0]);
        _this.stepSize = stepSize;
        _this.horizontalPass = horizonal;
        return _this;
    }
    Object.defineProperty(BlurTask.prototype, "name", {
        get: function () {
            return "FilterBlurTask:" + (this.horizontalPass ? 'hor' : 'vert') + ":" + this._amount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurTask.prototype, "amount", {
        get: function () {
            return this._amount;
        },
        set: function (value) {
            if (this._amount == value)
                return;
            this._amount = value;
            this.invalidateProgram();
            this.calculateStepSize();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurTask.prototype, "stepSize", {
        get: function () {
            return this._stepSize;
        },
        set: function (value) {
            if (this._stepSize == value)
                return;
            this._stepSize = value;
            this.calculateStepSize();
            this.invalidateProgram();
        },
        enumerable: false,
        configurable: true
    });
    BlurTask.prototype.getFragmentCode = function () {
        var hor = this.horizontalPass;
        var body = [];
        var count = 1;
        for (var x = this._realStepSize; x <= this._amount; x += this._realStepSize) {
            body.push("\n\t\t\t\t\t\tuv." + (hor ? 'x' : 'y') + " += uBlurData[1];\n\t\t\t\t\t\tcolor += texture2D(fs0, uv);\n\t\t\t");
            ++count;
        }
        return "\n\t\t\tprecision highp float;\n\t\t\tuniform vec3 uBlurData;\n\t\t\tuniform sampler2D fs0;\n\n\t\t\tvarying vec2 vUv;\n\t\t\t\n\t\t\tvoid main() {\n\t\t\t\tvec2 uv = vUv.xy;\n\t\t\t\tuv." + (hor ? 'x' : 'y') + " -= uBlurData[0];\n\n\t\t\t\tvec4 color = texture2D(fs0, uv);\n\n\t\t\t\t" + body.join('\n') + "\n\n\t\t\t\tgl_FragColor = color * 1.0 / " + count.toFixed(1) + ";\n\t\t\t}\n\t\t";
    };
    BlurTask.prototype.activate = function (_stage, _projection, _depthTexture) {
        _super.prototype.computeVertexData.call(this);
        var program = this._program3D;
        this._source.getAbstraction(_stage).activate(0);
        program.uploadUniform('uTexMatrix', this._vertexConstantData);
        program.uploadUniform('uBlurData', this._data);
    };
    BlurTask.prototype.preActivate = function (_stage) {
        this.updateBlurData();
    };
    BlurTask.prototype.updateBlurData = function () {
        // todo: must be normalized using view size ratio instead of texture
        var size = this.horizontalPass
            ? this._source.width
            : this._source.height;
        this._data[0] = this._amount * .5 / size;
        this._data[1] = this._realStepSize / size;
    };
    BlurTask.prototype.calculateStepSize = function () {
        this._realStepSize = this._stepSize > 0
            ? this._stepSize
            : this._amount > BlurTask.MAX_AUTO_SAMPLES
                ? this._amount / BlurTask.MAX_AUTO_SAMPLES
                : 1;
    };
    BlurTask.MAX_AUTO_SAMPLES = 15;
    return BlurTask;
}(TaskBaseWebGL /*Filter3DTaskBase*/));
export { BlurTask };
